const route = [
    //添加班级
    {
        path: '/classlist/add',
        component: function (resolve) {
            require(['VIEWS/class/add.vue'], resolve);
        },
    },
    //班级详情
    {
        path: '/classlist/detail/:sid/:unit_class_id',
        component: function (resolve) {
            require(['VIEWS/class/detail.vue'], resolve);
        },
    },
    //添加学生-搜索
    {
        path: '/classlist/search/:unit_class_id',
        component: function (resolve) {
            require(['VIEWS/class/search.vue'], resolve);
        },
    },
    //添加学生-搜索结果
    {
        path: '/classlist/result/:unit_class_id',
        component: function (resolve) {
            require(['VIEWS/class/result.vue'], resolve);
        },
    },
    //添加学生-学校列表
    {
        path: '/classlist/school/:county_id',
        component: function (resolve) {
            require(['VIEWS/class/school.vue'], resolve);
        },
    },
];
export default route
